<template>
  <router-view />
</template>

<script>
export default {
  name: "app-course"
};
</script>

<style lang="scss" scoped></style>
